import { ArrowRight, TrendingUp, ShieldCheck, ChartBar as BarChart3 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Herogrowthstrategy() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const details = [{
    icon: TrendingUp,
    label: "REVENUE"
  }, {
    icon: ShieldCheck,
    label: "STRATEGY"
  }, {
    icon: BarChart3,
    label: "INSIGHTS"
  }];
  return <section data-section-id="2753" id="herogrowthstrategy" className="bg-slate-50 text-slate-900 relative w-full overflow-hidden">
      <div className="grid min-h-[90vh] grid-cols-1 lg:grid-cols-12">
        {}
        <div ref={leftRef} className={`col-span-1 lg:col-span-6 bg-white text-slate-900 flex items-center min-h-[60vh] lg:min-h-[90vh] px-6 sm:px-10 lg:px-20 py-16 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="max-w-xl w-full">
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-blue-600" aria-hidden="true" />
              <span className="font-default text-[11px] tracking-[0.3em] uppercase text-blue-600">
                HotelRevBaBa Consulting
              </span>
            </div>

            {}
            <h1 className="font-default font-bold leading-[1.02] text-slate-900" style={{
            fontSize: "clamp(3.5rem, 6vw, 6rem)"
          }}>
              Maximize Your Hotel’s{" "}
              <span className="relative inline-block italic text-blue-700">
                Revenue
                <span className="absolute left-0 -bottom-2 h-px w-full bg-blue-600" aria-hidden="true" />
              </span>
              .
            </h1>

            {}
            <p className="font-default mt-10 text-lg sm:text-xl leading-relaxed text-slate-700 max-w-md">
              Unlock your property's full potential with data-driven OTA strategies, 
              expert revenue management, and cutting-edge hospitality technology 
              solutions tailored for maximum profitability.
            </p>

            {}
            <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5 sm:gap-8">
              <Button asChild size="lg" className="rounded-lg h-12 px-7 bg-blue-600 text-white hover:bg-blue-700 font-default text-[11px] tracking-[0.25em] uppercase shadow-md">
                <Link to="/ContactPage">Book a Consultation</Link>
              </Button>

              <Link to="#" className="font-default text-[11px] tracking-[0.25em] uppercase text-slate-900 hover:text-blue-700 transition-colors inline-flex items-center gap-2 group">
                View Our Services
                <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            {}
            <div className="mt-16 pt-8 border-t border-slate-200 flex items-center gap-8 sm:gap-12">
              {details.map((item, i) => {
              const Icon = item.icon;
              return <div data-index={i} key={item.label} className="flex items-center gap-3">
                    <Icon className="size-4 text-blue-600" strokeWidth={1.25} />
                    <span className="font-default text-[11px] tracking-[0.3em] uppercase text-slate-600">
                      {item.label}
                    </span>
                  </div>;
            })}
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`col-span-1 lg:col-span-6 relative bg-slate-50 min-h-[60vh] lg:min-h-[90vh] overflow-visible transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="absolute inset-0 lg:-right-10 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png-wvc-sizes" alt="Professional hotel revenue management dashboard showing growth analytics and OTA performance metrics" loading="lazy" decoding="async" className="w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "radial-gradient(ellipse at center, transparent 50%, hsla(222, 47%, 7%, 0.4) 100%)"
          }} aria-hidden="true" />
            {}
            <div className="absolute inset-y-0 left-0 w-1/3 pointer-events-none opacity-40" style={{
            background: "linear-gradient(to right, hsla(222, 47%, 7%, 0.18), transparent)"
          }} aria-hidden="true" />
          </div>

          {}
          <div className="hidden lg:flex absolute top-10 right-12 z-10 items-center gap-3">
            <span className="font-default text-[11px] tracking-[0.3em] uppercase text-white/80">
              Expertise
            </span>
            <span className="h-px w-8 bg-white/30" aria-hidden="true" />
          </div>

          <div className="hidden lg:block absolute bottom-10 right-12 z-10 max-w-[220px] text-right">
            <p className="font-default italic text-white/90 text-base leading-snug">
              "Transforming hospitality data into sustainable revenue growth for your property."
            </p>
          </div>
        </div>
      </div>
    </section>;
}